import { Component, computed, inject, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { TextField, type ImageField, type LinkField } from '@core/jss-proxy';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';
import { LogosSectionComponent } from '@content/ui/logos';
import { FieldService, getField } from '@core/jss-utils';

interface ContactSectionComponentRendering extends InnogyComponentRendering {
  title: TextField;
  introduction: TextField;
}

@Component({
  selector: 'wl-logos-section-container',
  standalone: true,
  templateUrl: './logos-section-container.component.html',
  imports: [ContentSectionComponent, LogosSectionComponent],
})
export class LogosSectionContainerComponent {
  readonly rendering = input.required<ContactSectionComponentRendering>();

  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);

  readonly uid = computed(() => this.rendering().uid);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly introduction = computed(() =>
    getField<TextField>(this.fields(), 'introduction')
  );

  readonly #fieldService = inject(FieldService);

  readonly logos = computed(() => {
    const fields = this.fields();

    return Array.from({ length: 6 }).flatMap((_, i) => {
      const index = i + 1;
      const image = getField<ImageField>(fields, `logoImage${index}`);
      const link = getField<LinkField>(fields, `logoLink${index}`);

      if (!this.#fieldService.showImageField(image)) {
        return [];
      }

      return [
        {
          image,
          link: this.#fieldService.showLinkField(link) ? link : undefined,
        },
      ];
    });
  });
}
